import React, { useEffect, useState } from "react";
import './App.scss';

const API_KEY = "f66827653dae53ff697c1dabc095e7da";
const USERNAME = "ragetegar";
const ENDPOINT = `https://ws.audioscrobbler.com/2.0/?method=user.getrecenttracks&user=${USERNAME}&api_key=${API_KEY}&format=json`;

const App = () => {
  const [track, setTrack] = useState({
    title: "Title",
    artist: "Artist",
    albumArt: "",
  });

  const fetchNowPlaying = async () => {
    try {
      const response = await fetch(ENDPOINT);
      const data = await response.json();

      const trackData = data.recenttracks.track[0];
      const title = trackData.name;
      const artist = trackData.artist["#text"];
      const albumArt =
        trackData.image.find((img) => img.size === "extralarge")?.["#text"] ||
        trackData.image.find((img) => img.size === "large")?.["#text"] ||
        trackData.image.find((img) => img.size === "medium")?.["#text"] ||
        trackData.image.find((img) => img.size === "small")?.["#text"] ||
        "";

        const updatedAlbumArt = albumArt.replace("/300x300/", "/500x500/");
        setTrack({ title, artist, albumArt: updatedAlbumArt });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch track when the component mounts
  useEffect(() => {
    fetchNowPlaying();
    // Poll the track every 10 seconds to update the now-playing information
    const interval = setInterval(fetchNowPlaying, 10000); // Update every 10 seconds

    // Clean up the interval when the component is unmounted
    return () => clearInterval(interval);
  }, []); // Empty dependency array to run this effect once on mount

  return (
    <div id="wrap">
      <div id="album">
        <div className="info-song">
          <h2 id="track-title">{track.title}</h2>
          <h2 id="track-artist">{track.artist}</h2>
        </div>
        <div
          id="cover"
          style={{ backgroundImage: `url('${track.albumArt}')` }}
        ></div>
        <div id="vinyl">
          <div id="print"></div>
        </div>
      </div>
    </div>
  );
};

export default App;
